import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';
import TailoredActionName from '../../store/schema/telemetry/TailoredActionName';
import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import getCustomDataForDirtyFields from './getCustomDataForDirtyFields';
import getDetailsEditableField from '../view/getDetailsEditableField';
import { PerformanceDatapoint } from 'owa-analytics';

/**
 * Create Save event perf datapoint and add data to it
 */
export default function createSaveEventDataPoint(
    cardItem: CardItem,
    summaryEditableField: string,
    displayAddress: string,
    getPerfDatapointLogger: (datapointName: string) => any
): PerformanceDatapoint {
    let perfDatapoint = getPerfDatapointLogger(TailoredActionName.SaveCard);
    perfDatapoint.addCustomData({
        [LogNames.activityType]: cardItem.activityType,
        [LogNames.hasLocation]: !!getDetailsEditableField(cardItem.detailsData),
    });
    perfDatapoint.addCustomData(
        getCustomDataForDirtyFields(cardItem, summaryEditableField, displayAddress)
    );
    return perfDatapoint;
}
